module.exports = __webpack_public_path__ + "bin/f41e93ecd49be75e03c56774295ab015.png";